var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "person-item-wrapper" }, [
    _c(
      "div",
      {
        staticClass: "person-item",
        attrs: { "data-toggle": "tooltip-city", "data-placement": "right" },
        on: {
          click: function ($event) {
            $event.preventDefault()
            return _vm.openPersonDetail.apply(null, arguments)
          },
        },
      },
      [
        _c("p", { staticClass: "full-name" }, [_vm._v(_vm._s(_vm.personName))]),
        _vm._v(" "),
        _c("p", { staticClass: "role" }, [
          _vm._v(
            " " +
              _vm._s(_vm.$t(`${_vm.translateID}.form.type.${_vm.personType}`)) +
              " "
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }